import { render, staticRenderFns } from "./ContractContactHistoryTab.vue?vue&type=template&id=bd86c48a&"
import script from "./ContractContactHistoryTab.vue?vue&type=script&lang=js&"
export * from "./ContractContactHistoryTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports